import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Link, useNavigate } from 'react-router';
import isObject from 'lodash/isObject';
import { Button, Card, Col, Row, Space } from 'antd';
import { RiArrowLeftLine } from 'react-icons/ri';
import useNavigationSource from '../../../../../app/hooks/useNavigationSource';
import { SOURCES_MAP } from '../../../../../const/sources';
import appRoutes from '@/configs/routes';
import handleResponse from '../../../../../lib/handleResponse';
import transformErrors from '../../../../../lib/transformErrors';
import { BreadCrumbs, IntlMessages } from '@/components';
import FormCreateCollection from '../../../forms/FormCreateCollection';
import getFeatureSourceTranslation from '../../../../Featured/utils/getFeatureSourceTranslation';
import { useCreateCollectionMutation } from '../../../api/collectionsApiSlice';

const PageCreateCollection = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [errors, setFormErrors] = useState({});
  const { urlPrefix, navigationSource } = useNavigationSource(SOURCES_MAP.COLLECTIONS);

  const [createCollection, { isLoading: isCreatingCollection }] = useCreateCollectionMutation();

  const onSubmit = (values) => {
    createCollection({ values })
      .unwrap()
      .then((response) =>
        handleResponse('success', intl, 'ui-general-created-successfully', [
          () => setFormErrors({}),
          () =>
            navigate(
              appRoutes.urlPageCollectionEdit({
                urlPrefix,
                source: navigationSource,
                collectionId: response?.data?.id,
              }),
            ),
        ]),
      )
      .catch((error) => {
        handleResponse(
          'error',
          intl,
          'ui-general-create-failed',
          [
            () => {
              if (isObject(error?.data?.errors)) {
                setFormErrors(transformErrors(error?.data?.errors));
              }
            },
          ],
          error,
        );
      });
  };

  return (
    <>
      <Row gutter={[32, 32]} justify="space-between" className="hp-mb-12" align="middle">
        <BreadCrumbs
          breadCrumbParent={
            urlPrefix ? (
              <Link to={appRoutes.urlPageFeatures({ featureSource: urlPrefix })}>
                <IntlMessages id={getFeatureSourceTranslation(urlPrefix)} />
              </Link>
            ) : null
          }
          breadCrumbParent2={
            <Link to={appRoutes.urlPageCollections({ urlPrefix, source: navigationSource })}>
              <IntlMessages id="collections-breadcrumbs" />
            </Link>
          }
          breadCrumbActive={<IntlMessages id="ui-general-create" />}
        />

        <Col md={12} span={24}>
          <Row gutter={[8, 8]} justify="end" align="middle">
            <Col>
              <Space>
                <Link to={appRoutes.urlPageCollections({ urlPrefix, source: navigationSource })}>
                  <Button
                    type="primary"
                    className="hp-mr-sm-8"
                    ghost="true"
                    icon={<RiArrowLeftLine className="hp-mr-8" size={18} />}
                  >
                    <IntlMessages id="ui-general-back-to-list" />
                  </Button>
                </Link>
              </Space>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row gutter={[32, 32]}>
        <Col span={24}>
          <Card className="hp-border-color-black-40 hp-card-6">
            <FormCreateCollection
              initialErrors={errors}
              isSubmitting={isCreatingCollection}
              onSubmit={onSubmit}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default PageCreateCollection;
